import { z } from "zod/v4";

import { CreateShippingRateGroupDtoSchema } from "../dtos/shipping-rate-groups";

import { ShippingRateFeSchema } from "./shipping-rate";

export const ShippingRateGroupFeSchema =
  CreateShippingRateGroupDtoSchema.extend({
    rates: ShippingRateFeSchema.array(),
  });
export type ShippingRateGroupFe = z.infer<typeof ShippingRateGroupFeSchema>;
